'use client';

import { useEffect } from 'react';

import { useNavigation } from '@/hooks/navigation';
import { useInfoProject } from '@/modules/common';
import { License } from '@/store/commonStore/types';

export default function useEstonia() {
  const { data: project, isLoading: projectPending } = useInfoProject();
  const isEELicense = project?.license === License.EE;
  return { isEstonia: isEELicense, isEstoniaLoading: projectPending };
}

export const useRestrictRoutesForEstonia = () => {
  const { isEstonia } = useEstonia();
  const { navigate } = useNavigation();

  useEffect(() => {
    if (isEstonia) {
      navigate('/');
    }
  }, [isEstonia, navigate]);
};
